<template>
    <div>
      <h3 data-aos="fade-left" >{{ $t('ac_cleaning.scope_of_service_section.title') }}</h3>
      <p data-aos="fade-right" class="sub-text py-2" v-html="$t(`ac_cleaning.scope_of_service_section.subtitle`)"></p>
      <div v-for="(detail, index) in details" :key="index" class="details">
        <img src="/static/img/acCleaning/svg/Check.svg" />
        <!-- <p class="list" v-html="detail.detail"></p> -->
        <p class="list" v-html="$t(`ac_cleaning.scope_of_service_section.service_items.${index}`)"></p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data () {
      return {
        title: 'ขอบเขตการบริการ (บริการครบ จบในครั้งเดียว)',
        subtitle: `BeNeat มอบประสบการณ์ล้างแอร์อย่างมืออาชีพ พร้อมมาตรฐานการทำงานที่ชัดเจน ครอบคลุมตั้งแต่ต้นจนจบ เพื่อให้ลูกค้ามั่นใจว่า <br/> “แอร์ของคุณสะอาด เย็นเร็ว และปลอดภัยแน่นอน”`,
        details: [
          {
            detail: `ตรวจสอบการทำงานเบื้องต้นถอดล้างชิ้นส่วนสำคัญอย่างละเอียด`
          },
          {
            detail: `ฉีดล้างด้วยน้ำแรงดันสูงอย่างปลอดภัย`
          },
          {
            detail: `ล้างท่อน้ำทิ้ง และไล่สิ่งอุดตัน`
          },
          {
            detail: `ทำความสะอาดพื้นที่หน้างานหลังจบงาน`
          },
          {
            detail: `ทดสอบแอร์หลังล้างเสร็จ`
          }
        ]
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  @import '../../../static/sass/page/ac_cleaning.scss';
  
  .details {
    display: flex;
    gap: 8px;
    place-items: center;
    margin-bottom: 16px;
    img {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }
  
  </style>
  


// WEBPACK FOOTER //
// src/components/acCleaningRe/ScopeOfWork.vue